var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNewDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 0C11.1694 0 10.4991 0.670312 10.4991 1.5V2.4C7.07723 3.09375 4.4991 6.12187 4.4991 9.75V10.6313C4.4991 12.8344 3.68817 14.9625 2.22567 16.6125L1.87879 17.0016C1.48504 17.4422 1.39129 18.075 1.63035 18.6141C1.86942 19.1531 2.40848 19.5 2.9991 19.5H20.9991C21.5897 19.5 22.1241 19.1531 22.3679 18.6141C22.6116 18.075 22.5132 17.4422 22.1194 17.0016L21.7725 16.6125C20.31 14.9625 19.4991 12.8391 19.4991 10.6313V9.75C19.4991 6.12187 16.921 3.09375 13.4991 2.4V1.5C13.4991 0.670312 12.8288 0 11.9991 0ZM14.1225 23.1234C14.685 22.5609 14.9991 21.7969 14.9991 21H11.9991H8.9991C8.9991 21.7969 9.31316 22.5609 9.87566 23.1234C10.4382 23.6859 11.2022 24 11.9991 24C12.796 24 13.56 23.6859 14.1225 23.1234Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 5,
    fill: "#D62516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNewDesktop);
export default __webpack_public_path__ + "static/media/notification_new_desktop.5acbd7c94762be24bf739c130bb2b57f.svg";
export { ForwardRef as ReactComponent };